const kanaMap = {
    ア: "ｱ", イ: "ｲ", ウ: "ｳ", エ: "ｴ", オ: "ｵ",
    カ: "ｶ", キ: "ｷ", ク: "ｸ", ケ: "ｹ", コ: "ｺ",
    サ: "ｻ", シ: "ｼ", ス: "ｽ", セ: "ｾ", ソ: "ｿ",
    タ: "ﾀ", チ: "ﾁ", ツ: "ﾂ", テ: "ﾃ", ト: "ﾄ",
    ナ: "ﾅ", ニ: "ﾆ", ヌ: "ﾇ", ネ: "ﾈ", ノ: "ﾉ",
    ハ: "ﾊ", ヒ: "ﾋ", フ: "ﾌ", ヘ: "ﾍ", ホ: "ﾎ",
    マ: "ﾏ", ミ: "ﾐ", ム: "ﾑ", メ: "ﾒ", モ: "ﾓ",
    ヤ: "ﾔ", ユ: "ﾕ", ヨ: "ﾖ",
    ラ: "ﾗ", リ: "ﾘ", ル: "ﾙ", レ: "ﾚ", ロ: "ﾛ",
    ワ: "ﾜ", ヲ: "ｦ", ン: "ﾝ",
    ァ: "ｧ", ィ: "ｨ", ゥ: "ｩ", ェ: "ｪ", ォ: "ｫ",
    ャ: "ｬ", ュ: "ｭ", ョ: "ｮ", ッ: "ｯ",
    ー: "ｰ"
};

const dakutenMap = {
    ガ: "ｶﾞ", ギ: "ｷﾞ", グ: "ｸﾞ", ゲ: "ｹﾞ", ゴ: "ｺﾞ",
    ザ: "ｻﾞ", ジ: "ｼﾞ", ズ: "ｽﾞ", ゼ: "ｾﾞ", ゾ: "ｿﾞ",
    ダ: "ﾀﾞ", ヂ: "ﾁﾞ", ヅ: "ﾂﾞ", デ: "ﾃﾞ", ド: "ﾄﾞ",
    バ: "ﾊﾞ", ビ: "ﾋﾞ", ブ: "ﾌﾞ", ベ: "ﾍﾞ", ボ: "ﾎﾞ",
    パ: "ﾊﾟ", ピ: "ﾋﾟ", プ: "ﾌﾟ", ペ: "ﾍﾟ", ポ: "ﾎﾟ",
    ヴ: "ｳﾞ",
};
//半角カナ変換
export const toHalfWidthKana = (value) => {
    return value
        // ひらがな → カタカナ
        .replace(/[\u3041-\u3096]/g, (ch) =>
            String.fromCharCode(ch.charCodeAt(0) + 0x60)
        )
        // ② カタカナ → 半角
        .split("")
        .map((char) => {
            if (dakutenMap[char]) return dakutenMap[char];
            if (kanaMap[char]) return kanaMap[char];
            return char;
        })
        .join("")
        .replace(/\u3000/g, " ");
};
//半角英字変換
export const toHalfWidthAlpha = (str) => {
    return str.replace(/[Ａ-Ｚａ-ｚ]/g, (s) =>
        String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
    )
        .replace(/\u3000/g, " ");
};
//半角数字変換
export const toHalfWidthNumber = (str) => {
    return str.replace(/[０-９]/g, (s) =>
        String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
    );
};